<template>
  <div class="fourElements">
    <div class="fourElementsContainer">
      <div class="oh fl mr20">
        <div class="fl lh30">品牌：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.brandId"
            style="width: 120px"
            @change="initList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in brands"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>

      <div class="oh fl mr20">
        <div class="fl lh30">渠道：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.channelId"
            style="width: 120px"
            @change="initList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in channels"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>

      <div class="oh fl  mr20">
        <div class="fl lh30">站点：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.siteId"
            style="width: 120px"
            @change="initList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in sites"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="oh fl">
        <div class="fl lh30">终端：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.terminalId"
            style="width: 120px"
            @change="initList"
          >
            <a-select-option :value="1" key="web">WEB</a-select-option>
            <a-select-option :value="2" key="app">APP</a-select-option>
          </a-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.fourElements {
  background: #ffffff;
  padding: 10px 20px 20px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.fourElementsContainer {
  display: flex;
  flex-direction: row;
}
</style>
